
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';
import * as THREE from 'three';
import Engine from '../Engine';
import AssetUtility from '../AssetUtility';
import { BuiltInCubeMaps } from '../../interfaces/Misc';
import { ImageSelectorOptions } from '../../components/properties/ImageSelectorProperty';
import StandbyOverlay from '../../components/layout/StandbyOverlay';

export const envMapSelectorOptions: ImageSelectorOptions[] = [
	{ assetId: BuiltInCubeMaps.Default, previewPath: "./HDR/Preview_Default.png", name: "None" },
	{ assetId: BuiltInCubeMaps.Studio, previewPath: "./HDR/Preview_Studio.png", name: "Studio" },
	{ assetId: BuiltInCubeMaps.Interior, previewPath: "./HDR/Preview_Interior.png", name: "Inside" },
	{ assetId: BuiltInCubeMaps.Outside, previewPath: "./HDR/Preview_Outside.png", name: "Outside" },
];
export default class CubemapUtils
{
	static cubemapBank = new Map();
	static getCubemap(assetId: string = BuiltInCubeMaps.Default)
	{
		if (CubemapUtils.cubemapBank.has(assetId))
		{
			return CubemapUtils.cubemapBank.get(assetId);
		}
		return null;
	}

	static loadCubemap(assetId: string = BuiltInCubeMaps.Default) : Promise<THREE.Texture>
	{
		return new Promise(function (resolve, reject)
		{
			if (CubemapUtils.cubemapBank.has(assetId) && CubemapUtils.cubemapBank.get(assetId))
			{
				resolve(CubemapUtils.cubemapBank.get(assetId));
			}

			StandbyOverlay.startStandbyMode("Loading Content");
			let textureURL : string;
			switch (assetId)
			{
				case BuiltInCubeMaps.Default:
					textureURL = 'HDR/skybox.hdr';
					break;
				case BuiltInCubeMaps.Studio:
					textureURL = 'HDR/CreateStudio.hdr';
					break;
				case BuiltInCubeMaps.Interior:
					textureURL = 'HDR/CreateInterior.hdr';
					break;
				case BuiltInCubeMaps.Outside:
					textureURL = 'HDR/CreateOutside.hdr';
					break;
				default:
					textureURL = AssetUtility.getRawAssetURL(assetId);
					break;
			}
	
			const fileExtension = textureURL.slice((textureURL.lastIndexOf(".") - 1 >>> 0) + 2).toLowerCase();
			if (fileExtension === 'hdr')
			{
				const pmremGenerator = new THREE.PMREMGenerator(Engine.getInstance().getRenderer());
				pmremGenerator.compileEquirectangularShader();
				new RGBELoader().setPath('').load(textureURL, function (texture)
				{
					texture.colorSpace = THREE.SRGBColorSpace;
					const cubemap = pmremGenerator.fromEquirectangular(texture).texture;
					cubemap["assetId"] = assetId;
					CubemapUtils.cubemapBank.set(assetId, cubemap);
					texture.dispose();
					pmremGenerator.dispose();
					StandbyOverlay.stopStandbyMode();
					resolve(cubemap);

				}, () => { },
				() =>
				{
					StandbyOverlay.stopStandbyMode();
					reject();
				});
			}
			else
			{
				new THREE.TextureLoader().load(textureURL, function (texture)
				{
					//texture.encoding = THREE.sRGBEncoding;
					texture.mapping = THREE.EquirectangularReflectionMapping;
					// const renderTarget = new THREE.WebGLCubeRenderTarget(texture.image.height);
					// renderTarget.fromEquirectangularTexture(engine.getRenderer(), texture);
					// texture.dispose();
					// const cubemap = renderTarget.texture;
					const cubemap = texture;
					cubemap["assetId"] = assetId;
					CubemapUtils.cubemapBank.set(assetId, cubemap);
					StandbyOverlay.stopStandbyMode();
					resolve(cubemap);
				}, () => { },
				() =>
				{
					StandbyOverlay.stopStandbyMode();
					reject();
				});
			}
		});
	}

	static disposeCubemaps()
	{
		CubemapUtils.cubemapBank.forEach(function (cubemap, assetId)
		{
			if (assetId !== BuiltInCubeMaps.Default && cubemap && typeof cubemap.dispose === 'function')
			{
				cubemap.dispose();
				cubemap = undefined;
			}
		});
	}

}

